/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QueryAttributesExperimentResultDTO } from './QueryAttributesExperimentResultDTO';
import {
    QueryAttributesExperimentResultDTOFromJSON,
    QueryAttributesExperimentResultDTOFromJSONTyped,
    QueryAttributesExperimentResultDTOToJSON,
} from './QueryAttributesExperimentResultDTO';
import type { NextPageDTO } from './NextPageDTO';
import {
    NextPageDTOFromJSON,
    NextPageDTOFromJSONTyped,
    NextPageDTOToJSON,
} from './NextPageDTO';

/**
 * 
 * @export
 * @interface QueryAttributesResultDTO
 */
export interface QueryAttributesResultDTO {
    /**
     * 
     * @type {Array<QueryAttributesExperimentResultDTO>}
     * @memberof QueryAttributesResultDTO
     */
    entries: Array<QueryAttributesExperimentResultDTO>;
    /**
     * 
     * @type {NextPageDTO}
     * @memberof QueryAttributesResultDTO
     */
    nextPage: NextPageDTO;
}

/**
 * Check if a given object implements the QueryAttributesResultDTO interface.
 */
export function instanceOfQueryAttributesResultDTO(value: object): value is QueryAttributesResultDTO {
    if (!('entries' in value) || value['entries'] === undefined) return false;
    if (!('nextPage' in value) || value['nextPage'] === undefined) return false;
    return true;
}

export function QueryAttributesResultDTOFromJSON(json: any): QueryAttributesResultDTO {
    return QueryAttributesResultDTOFromJSONTyped(json, false);
}

export function QueryAttributesResultDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): QueryAttributesResultDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'entries': ((json['entries'] as Array<any>).map(QueryAttributesExperimentResultDTOFromJSON)),
        'nextPage': NextPageDTOFromJSON(json['nextPage']),
    };
}

export function QueryAttributesResultDTOToJSON(value?: QueryAttributesResultDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'entries': ((value['entries'] as Array<any>).map(QueryAttributesExperimentResultDTOToJSON)),
        'nextPage': NextPageDTOToJSON(value['nextPage']),
    };
}

